























import { Component, Vue } from 'vue-property-decorator';
import catalogList from '@/components/catalog/catalogList.vue';
import projectsStatussesTable from '@/components/projects/projectStatussesTable.vue';
import NoteTypesTable from '@/components/projects/NoteTypesTable.vue';
import RawMaterialGroupTable from '@/components/articles/rawMaterialGroupTable.vue';
import VolumeDiscountsTable from '@/modules/quotations/components/VolumeDiscountsTable.vue';
import MeasuringUnitsTable from '@/modules/articles/components/MeasuringUnitsTable.vue';

@Component({
  components: {
    catalogList,
    projectsStatussesTable,
    NoteTypesTable,
    RawMaterialGroupTable,
    VolumeDiscountsTable,
    MeasuringUnitsTable
  },
})
export default class CatalogListOverview extends Vue {

}
